import { PermissionsE } from "../context/usePermissions";

export const canChangeStudyStatus = (hasPermission?: (permission: string) => boolean) => {
  if (!hasPermission) return false;

  return (
    hasPermission(PermissionsE.STUDY_META_WRITE) ||
    hasPermission(PermissionsE["study.w_meta"])
  );
};
